import React, { Fragment, useContext, useEffect, useState } from "react";
import { ProgrammeContext, UserContext } from "../../contexts/UserContext";
import useAxiosInterceptors from "../../hooks/httpConfig";

export function Flux() {
  const apiInstance = useAxiosInterceptors();
  const [user] = useContext(UserContext);
  const [program] = useContext(ProgrammeContext);
  const [notifications, setNotifications] = useState([]);
  const [NOTIFICATION_TYPES, setNotifTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("DEFAULT");

  /* Version 1 UseEffect simple sans filtre de type */
  /* useEffect(() => {
    if (!!user && !!program) {
      const nom = program?.programme?.nom; //nom du program
      console.log(user);
      const { email } = user; //email du user
      // Appel à l'api pour recuperer les notifications
      apiInstance
        .get(`/notifications/recipient/${email}/${nom}`)
        .then(({ data }) => {
          setNotifications(data);
        });
    }
  }, [user, program, apiInstance]); */

  /* Version 2 UseEffect & HandleTypeChange */
  /* useEffect(() => {
    if (!!user && !!program) {
      const nom = program?.programme?.nom; //nom du program
      const { email } = user; //email du user

      // Appel à l'api pour recuperer les notifications
      apiInstance
        .get(`/notifications/recipient/${email}/${nom}`)
        .then(({ data }) => {
          const { notifications, NOTIFICATION_TYPES } = data;
          setNotifications(notifications);
          setNotifTypes(NOTIFICATION_TYPES);
        });
    }
  }, [user, program, apiInstance]);

  const handleTypeChange = (e) => {
    const type = e.target.value;
    setSelectedType(type);

    const nomProg = program?.programme?.nom;
    const { email: userEmail } = user;
    const url =
      type === "ALL"
        ? `/notifications/recipient/${userEmail}/${nomProg}`
        : `/notifications/recipient/${userEmail}/${nomProg}?type=${type}`;

    apiInstance
      .get(url)
      .then(({ data }) => {
        setNotifications(data.notifications);
      })
      .catch((err) => console.error("Erreur API :", err));
  }; */

  /* Version 3 UseEffect avec filtre de type dans le useEffect */
  const fetchNotifications = (type = "ALL") => {
    const nomProg = program?.programme?.nom;
    const { email: userEmail } = user;
    const url =
      type === "ALL"
        ? `/notifications/recipient/${userEmail}/${nomProg}`
        : `/notifications/recipient/${userEmail}/${nomProg}?type=${type}`;

    apiInstance
      .get(url)
      .then(({ data }) => {
        setNotifications(data.notifications);
        if (data.NOTIFICATION_TYPES) setNotifTypes(data.NOTIFICATION_TYPES);
      })
      .catch((err) => console.error("Erreur API :", err));
  };

  useEffect(() => {
    if (user && program) fetchNotifications();
  }, [user, program]);

  const handleTypeChange = (e) => {
    const type = e.target.value;
    setSelectedType(type);
    fetchNotifications(type);
  };

  return (
    <Fragment>
      <div className="Content-Container">
        <div className="PageHeader">
          <div className="row">
            <div className="col-md-4">
              <h3 className="PageHeader-Title">Flux d’activités</h3>
            </div>
            <div className="col-md-8">
              <div className="FilterForm">
                <div className="FilterRow">
                  <div className="Input-Row Input-Tags">
                    <input
                      type="text"
                      name=""
                      value=""
                      onChange={() => {
                        console.log("name");
                      }}
                      className="InputField"
                      placeholder="Tags"
                      data-role="tagsinput"
                    />
                  </div>

                  {/* START INPUT ROW */}
                  {/* <div className="Input-Row Input-Select">
                    <select
                      className="SelectFilter"
                      name=""
                      defaultValue={"DEFAULT"}
                    >
                      <option value="DEFAULT" disabled>
                        Type
                      </option>
                      <option value="1">Type 1</option>
                      <option value="2">Type 2</option>
                      <option value="3">Type 3</option>
                    </select>
                  </div> */}
                  <div className="Input-Row Input-Select">
                    {/* <select className="SelectFilter" name="" defaultValue={"DEFAULT"} onChange={handleTypeChange}> */}
                    <select
                      className="SelectFilter"
                      name="type"
                      value={selectedType}
                      onChange={handleTypeChange}
                    >
                      <option value="ALL">Tous les types</option>
                      {NOTIFICATION_TYPES.map(({ value, label }) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/*  END INPUT ROW  */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Flux-Activities_List">
          {notifications.map((item) => (
            <div className="NotificationItem" key={item._id}>
              <div className="NotificationItem-Thumb"></div>
              <div className="NotificationItem-Content">
                <span className="NotificationItem-Text">{item.message}</span>
                <span className="NotificationItem-Time">{item.time}</span>
              </div>
              <a href={item.url} className="NotificationLink">
                Voir plus
              </a>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
}
